import { Stack } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { Header } from "../../ui/layouts/DefaultLayout/Header";
import NotFoundContent from "../../ui/components/NotFoundContent/NotFoundContent";
import Seo from "../../ui/components/Seo/Seo";

interface NotFoundPageProps {}

const NotFoundPage: FunctionComponent<NotFoundPageProps> = () => {
  return (
    <>
      <Seo
        description={`Сторінку не знайдено 404`}
        title={"Сторінку не знайдено"}
        noindex
      />
      <Stack height="100vh">
        <Header />
        <NotFoundContent />
      </Stack>
    </>
  );
};

export default NotFoundPage;
